export const languageData = {
    xd: {
        greeting: "(づ｡◕‿‿◕｡)づ",
        name: "My name is Ryan",
    },
    en: {
        greeting: "Nice to meet you",
        name: "My name is Ryan",
    },
    cn: {
        greeting: "你好",
        name: "我叫林俊伟",
    },
    jp: {
        greeting: "はじめまして",
        name: "私の名前はライアンです",
    },
    kr: {
        greeting: "반가워요",
        name: "나는 라이언"
    }
};